export default __webpack_public_path__ + "static/media/LM_logo.023f9295.png";